import { defineStore } from 'pinia'
import enums from '@/utils/enums'
import resource from '@/assets/data/resource'

export const useBaseStore = defineStore('base', {
  state: () => {
    return {
      bodyHeight: document.body.clientHeight,
      bodyWidth: document.body.clientWidth,
      maskDialog: false,
      maskDialogMode: 'dark',
      version: '17.1.0',
      excludeNames: [],
      judgeValue: 20,
      homeRefresh: 60,
      loading: false,
      routeData: null,
      users: [],
      userinfo: {
        truename: '',
        useravatar: '',
        userid: '',
        usermobile: '',
        username: '',
        key: '',
      },
      message: ''
    }
  },
  getters: {

  },
  actions: {
    async init() {

    },
    async setUserInfo(userData) {
      this.userinfo = {
        ...this.userinfo,
        ...userData,
      };
      localStorage.setItem('userinfo', JSON.stringify(userData))
    },
    loadUser() {
      const saved = localStorage.getItem('userinfo') ?? '';
      if (saved && saved != 'undefined'){
        this.userinfo = JSON.parse(saved)
         
      }
    },
    logout() {
      this.userinfo.username = null
      this.userinfo.key = null
      this.userinfo.useravatar = null
      this.userinfo.usermobile = null
      this.userinfo.userid = null
      this.userinfo.truename = null
      
      localStorage.removeItem('userinfo')
    },
    setBaseIndex(index) {
      this.baseIndex = index;
    },
    setMaskDialog(val) {
      this.maskDialog = val.state
      if (val.mode) {
        this.maskDialogMode = val.mode
      }
    },
    updateExcludeNames(val) {
      if (val.type === 'add') {
        if (!this.excludeNames.find((v) => v === val.value)) {
          this.excludeNames.push(val.value)
        }
      } else {
        const resIndex = this.excludeNames.findIndex((v) => v === val.value)
        if (resIndex !== -1) {
          this.excludeNames.splice(resIndex, 1)
        }
      }
      // console.log('store.excludeNames', store.excludeNames,val)
    }
  }
})
